// src/components/LegalNotice.jsx
import React from 'react';
import styles from './Policies.module.css';
import { Link } from 'react-router-dom';
import { useTheme } from './context/ThemeContext';

const LegalNotice = () => {
  const { theme } = useTheme();

  return (
    <div className={`${styles.policyContainer} ${theme === "dark" ? "dark" : ""} ${styles[theme]}`}>
      <div className={styles.policyHeader}>
        <h1 className={styles.title}>Legal Notice</h1>
        <p className={styles.effectiveDate}>Effective Date: February 2026</p>
      </div>

      <div className={styles.policyContent}>
        <div className={styles.intro}>
          <p>
            At Pixelmoon, we maintain a zero-tolerance policy towards fraudulent activities. This legal notice outlines our commitment to security, monitoring, and legal compliance to ensure a safe environment for all our users.
          </p>
        </div>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Visible Fraud Warning</h2>
          <div className={styles.subsection}>
            <div className={styles.warningBox}>
              WARNING: FRAUDULENT TRANSACTIONS WILL BE PROSECUTED TO THE FULLEST EXTENT OF THE LAW.
            </div>
            <p>
              Any attempt to use stolen credit cards, unauthorized payment accounts, or engage in chargeback fraud will result in immediate account suspension and blacklisting across our entire network. We reserve the right to report such activities to the relevant financial institutions and credit bureaus.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>2. Monitoring Notice</h2>
          <div className={styles.subsection}>
            <p>
              All activities on Pixelmoon are actively monitored. We use advanced AI-driven fraud detection systems to track IP addresses, device signatures, and transaction patterns. This monitoring is carried out in real-time to prevent unauthorized access and fraudulent transactions. By using our platform, you consent to this continuous monitoring for the purpose of maintaining a secure environment.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>3. Cooperation with Law Enforcement</h2>
          <div className={styles.subsection}>
            <p>
              We maintain direct communication channels with cybercrime divisions and international law enforcement agencies. We will proactively share evidence, transaction logs, and identifying information with the authorities to assist in the investigation and prosecution of cybercriminals. We fully comply with all lawful requests for information and provide full cooperation in criminal investigations.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>4. Deterrence Policy</h2>
          <div className={styles.subsection}>
            <div className={styles.deterrenceText}>
              "Hackers avoid targets with legal heat."
            </div>
            <p>
              Pixelmoon is committed to making our platform a high-risk target for malicious actors. Our rigorous legal stance and advanced security protocols serve as a clear deterrent to those intending to cause harm or commit fraud. We actively pursue legal action against individuals who attempt to compromise our systems or defraud our users.
            </p>
          </div>
        </section>

        <div className={styles.policyLinks}>
          <Link to="/terms" className={styles.policyLink}>
            Terms & Conditions
          </Link>
          <Link to="/privacy" className={styles.policyLink}>
            Privacy Policy
          </Link>
          <Link to="/refund" className={styles.policyLink}>
            Refund Policy
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LegalNotice;
